module.exports = __webpack_public_path__ + "static/media/FormCheckbox_Checked.afbb2c90.svg";